import React from 'react';
import { 
  Activity, HeartPulse, Zap, Brain, GraduationCap, ShieldCheck, Target, Compass, BrainCircuit, 
  Users, AlertCircle, Shield, AlertTriangle, 
  BarChart3, Sparkles, Download, Loader2, Scale 
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const Dass21ReportUI = ({ data, meta }) => {
  // 🔥 DÜZELTME: Veritabanından (özellikle 30 Mart gibi eski tarihlerden) gelen 
  // NaN veya undefined değerlerini anında 0'a çevirerek çöküşü durduruyoruz.
  const rawScores = data.scores || { D: 0, A: 0, S: 0 };
  const scores = {
      D: Number(rawScores.D) || 0,
      A: Number(rawScores.A) || 0,
      S: Number(rawScores.S) || 0
  };
  
  // Klinik Kesme Noktaları (Cut-off) - Orijinal DASS Normları
  const getLevel = (type, score) => {
      if (type === 'D') return score <= 9 ? { l: "Normal", c: "text-emerald-600", bg: "bg-emerald-500", p: 20 } : score <= 13 ? { l: "Hafif", c: "text-amber-500", bg: "bg-amber-400", p: 40 } : score <= 20 ? { l: "Orta", c: "text-orange-500", bg: "bg-orange-500", p: 60 } : score <= 27 ? { l: "İleri", c: "text-red-500", bg: "bg-red-500", p: 80 } : { l: "Çok İleri", c: "text-rose-700", bg: "bg-rose-700", p: 100 };
      if (type === 'A') return score <= 7 ? { l: "Normal", c: "text-emerald-600", bg: "bg-emerald-500", p: 20 } : score <= 9 ? { l: "Hafif", c: "text-amber-500", bg: "bg-amber-400", p: 40 } : score <= 14 ? { l: "Orta", c: "text-orange-500", bg: "bg-orange-500", p: 60 } : score <= 19 ? { l: "İleri", c: "text-red-500", bg: "bg-red-500", p: 80 } : { l: "Çok İleri", c: "text-rose-700", bg: "bg-rose-700", p: 100 };
      if (type === 'S') return score <= 14 ? { l: "Normal", c: "text-emerald-600", bg: "bg-emerald-500", p: 20 } : score <= 18 ? { l: "Hafif", c: "text-amber-500", bg: "bg-amber-400", p: 40 } : score <= 25 ? { l: "Orta", c: "text-orange-500", bg: "bg-orange-500", p: 60 } : score <= 33 ? { l: "İleri", c: "text-red-500", bg: "bg-red-500", p: 80 } : { l: "Çok İleri", c: "text-rose-700", bg: "bg-rose-700", p: 100 };
  };

  const dep = getLevel('D', scores.D);
  const anx = getLevel('A', scores.A);
  const str = getLevel('S', scores.S);

  const isRedAlarm = scores.D >= 21 || scores.A >= 15 || scores.S >= 26;
  const isYellowAlarm = scores.D >= 14 || scores.A >= 10 || scores.S >= 19;

  // 1. Öncelikli Alan Tespiti
//
// Ham puanları birbiriyle doğrudan karşılaştırmıyoruz.
// Çünkü D, A ve S alt ölçeklerinin eşikleri farklıdır.
//
// Önce her alt ölçeğin bulunduğu düzeyi karşılaştırıyoruz.
// Aynı en yüksek düzeyde birden fazla alan varsa,
// yapay biçimde tek alan seçmek yerine "Birleşik" profil diyoruz.

const maxScoreVal =
  Math.max(
    scores.D,
    scores.A,
    scores.S
  );


const levelRank = {
  "Normal": 0,
  "Hafif": 1,
  "Orta": 2,
  "İleri": 3,
  "Çok İleri": 4
};


const severityByArea = {
  D:
    levelRank[dep.l] ?? 0,

  A:
    levelRank[anx.l] ?? 0,

  S:
    levelRank[str.l] ?? 0
};


const maxSeverity =
  Math.max(
    severityByArea.D,
    severityByArea.A,
    severityByArea.S
  );


const highestAreas =
  Object.entries(
    severityByArea
  )
    .filter(
      ([, rank]) =>
        rank === maxSeverity
    )
    .map(
      ([area]) =>
        area
    );


let primaryRisk =
  "Dengeli";


if (maxSeverity > 0) {

  if (
    highestAreas.length > 1
  ) {

    primaryRisk =
      "Birleşik";

  } else if (
    highestAreas[0] === "D"
  ) {

    primaryRisk =
      "Depresyon";

  } else if (
    highestAreas[0] === "A"
  ) {

    primaryRisk =
      "Anksiyete";

  } else if (
    highestAreas[0] === "S"
  ) {

    primaryRisk =
      "Stres";
  }
}

 // 2. DASS-21 Alt Ölçek Profil Özeti
//
// Burada yeni bir psikolojik yapı üretmiyoruz.
// Yalnızca D, A ve S alt ölçeklerinde hesaplanmış
// mevcut düzeyleri birlikte özetliyoruz.

let profileSummary = {
  l:
    "EŞİK ALTI PROFİL",

  c:
    "text-emerald-700",

  bg:
    "bg-emerald-50 border-emerald-200",

  text:
    "Depresyon, anksiyete ve stres alt ölçeklerinin üçü de normal aralıkta görünmektedir. Bu sonuç tek başına öğrencinin tüm yaşam alanlarında zorlanma bulunmadığını göstermez."
};


if (
  maxSeverity === 1
) {

  profileSummary = {
    l:
      "HAFİF DÜZEYDE BELİRTİ YÜKÜ",

    c:
      "text-amber-600",

    bg:
      "bg-amber-50 border-amber-200",

    text:
      "En az bir DASS-21 alt boyutunda hafif düzeyde yükselme görülmektedir. Bulgular öğrencinin yaşantısı ve işlevselliğiyle birlikte değerlendirilmelidir."
  };

}

else if (
  maxSeverity === 2
) {

  profileSummary = {
    l:
      "ORTA DÜZEYDE ZORLANMA",

    c:
      "text-orange-600",

    bg:
      "bg-orange-50 border-orange-200",

    text:
      "En az bir DASS-21 alt boyutunda orta düzeyde yükselme görülmektedir. Görüşmede bu belirtilerin günlük okul yaşantısına ve işlevselliğe nasıl yansıdığı araştırılmalıdır."
  };

}

else if (
  maxSeverity === 3
) {

  profileSummary = {
    l:
      "İLERİ DÜZEYDE ZORLANMA",

    c:
      "text-red-700",

    bg:
      "bg-red-50 border-red-200",

    text:
      "En az bir DASS-21 alt boyutunda ileri düzeyde yükselme görülmektedir. Sonucun bireysel görüşme, işlevsellik ve diğer değerlendirme verileriyle birlikte ele alınması önemlidir."
  };

}

else if (
  maxSeverity >= 4
) {

  profileSummary = {
    l:
      "ÇOK İLERİ DÜZEYDE ZORLANMA",

    c:
      "text-rose-700",

    bg:
      "bg-rose-50 border-rose-200",

    text:
      "En az bir DASS-21 alt boyutunda çok ileri düzeyde yükselme görülmektedir. Bu bulgu tek başına tanı anlamına gelmez; öğrencinin durumu bireysel görüşmede ayrıntılı olarak değerlendirilmelidir."
  };
}

  // 3. Bedensel Belirti Göstergeleri
//
// Toplam Anksiyete puanından bedensel belirti
// varsaymıyoruz.
//
// Yalnızca öğrencinin DASS-21'in doğrudan
// bedensel belirti içeren maddelerine verdiği
// gerçek yanıtları kullanıyoruz.

const somaticData =
  data?.somaticSignals;


const somaticItems =
  Array.isArray(
    somaticData?.items
  )
    ? somaticData.items
    : [];


const hasSomaticItemData =
  somaticItems.length > 0;


const reportedSomaticItems =
  somaticItems.filter(
    item =>
      Number(item?.value) >= 1
  );


const elevatedSomaticItems =
  somaticItems.filter(
    item =>
      Number(item?.value) >= 2
  );


const somaticItemNames =
  reportedSomaticItems
    .map(
      item =>
        item.label
    )
    .join(", ");


let somaticState = {

  l:
    "MADDE DÜZEYİ VERİ YOK",

  c:
    "text-slate-600",

  bg:
    "bg-slate-50 border-slate-200",

  text:
    "Bu kayıtta bedensel belirti maddelerine ait ayrıntılı yanıt verisi bulunmuyor. Toplam anksiyete puanı tek başına belirli bir bedensel belirtinin varlığını göstermez."
};


if (
  hasSomaticItemData
) {

  if (
    reportedSomaticItems.length === 0
  ) {

    somaticState = {

      l:
        "BELİRGİN BİLDİRİM YOK",

      c:
        "text-emerald-700",

      bg:
        "bg-emerald-50 border-emerald-200",

      text:
        "DASS-21'in bedensel belirtiyle ilişkili maddelerinde öğrenci tarafından belirgin bir bildirim yapılmamıştır."
    };

  }

  else if (
    elevatedSomaticItems.length >= 2 ||
    Number(
      somaticData?.maxValue
    ) >= 3
  ) {

    somaticState = {

      l:
        "BELİRGİN BEDENSEL BİLDİRİM",

      c:
        "text-red-700",

      bg:
        "bg-red-50 border-red-200",

      text:
        `Öğrenci bedensel belirtiyle ilişkili maddelerde ${somaticItemNames} alanlarını bildirmiştir. Bu bulguların ne zaman ve hangi durumlarda ortaya çıktığı bireysel görüşmede ayrıca değerlendirilmelidir.`
    };

  }

  else if (
    elevatedSomaticItems.length >= 1
  ) {

    somaticState = {

      l:
        "DİKKATE DEĞER BEDENSEL BİLDİRİM",

      c:
        "text-orange-700",

      bg:
        "bg-orange-50 border-orange-200",

      text:
        `Bedensel belirtiyle ilişkili maddelerde ${somaticItemNames} bildirilmiştir. Bu göstergeler tek başına bir neden veya tanı anlamına gelmez; öğrencinin yaşantısıyla birlikte değerlendirilmelidir.`
    };

  }

  else {

    somaticState = {

      l:
        "SINIRLI BEDENSEL BİLDİRİM",

      c:
        "text-amber-700",

      bg:
        "bg-amber-50 border-amber-200",

      text:
        `Öğrenci bedensel belirtiyle ilişkili maddelerde ${somaticItemNames} alanlarını düşük sıklıkta bildirmiştir. Görüşmede yalnızca gerekli görülürse bağlamı araştırılabilir.`
    };
  }
}

  // 4. Okul Yaşantısında Görüşmede Araştırılacak Alanlar
//
// DASS-21 akademik başarıyı, ders katılımını veya
// sınıf içi davranışı doğrudan ölçmez.
//
// Bu nedenle burada "etki tespit edildi" demiyoruz;
// yalnızca bireysel görüşmede araştırılması anlamlı
// olabilecek okul yaşantısı alanlarını gösteriyoruz.

let academicImpact = {

  l:
    "RUTİN GÖRÜŞME ÇERÇEVESİ",

  c:
    "text-emerald-700",

  bg:
    "bg-emerald-50 border-emerald-200",

  text:
    "DASS-21 sonuçları tek başına öğrencinin akademik işlevselliği hakkında bir sonuç oluşturmaz. Gerektiğinde motivasyon, derse katılım, dikkat ve okul uyumu rutin görüşme çerçevesinde ele alınabilir."
};


if (
  primaryRisk ===
  "Birleşik"
) {

  academicImpact = {

    l:
      "BİRDEN FAZLA ALANI BİRLİKTE ARAŞTIR",

    c:
      "text-violet-700",

    bg:
      "bg-violet-50 border-violet-200",

    text:
      "Birden fazla DASS-21 alt boyutunda benzer düzeyde yükselme görülmektedir. Görüşmede enerji, motivasyon, performans baskısı, akademik yük algısı ve sosyal işlevsellik birlikte değerlendirilmelidir."
  };

}

else if (
  primaryRisk ===
  "Depresyon"
) {

  academicImpact = {

    l:
      "ENERJİ VE MOTİVASYONU ARAŞTIR",

    c:
      "text-indigo-700",

    bg:
      "bg-indigo-50 border-indigo-200",

    text:
      "Görüşmede öğrencinin enerji düzeyi, okula ve derslere yönelik isteği, göreve başlama güçlüğü, dikkatini sürdürme ve günlük rutinlerinde değişim olup olmadığı araştırılabilir."
  };

}

else if (
  primaryRisk ===
  "Anksiyete"
) {

  academicImpact = {

    l:
      "PERFORMANS DURUMLARINI ARAŞTIR",

    c:
      "text-rose-700",

    bg:
      "bg-rose-50 border-rose-200",

    text:
      "Görüşmede sınavlar, sınıf içi değerlendirilme, söz alma, performans gerektiren durumlar ve kaygının öğrencinin bilgilerini göstermesini zorlaştırıp zorlaştırmadığı araştırılabilir."
  };

}

else if (
  primaryRisk ===
  "Stres"
) {

  academicImpact = {

    l:
      "YÜK VE RUTİNLERİ ARAŞTIR",

    c:
      "text-amber-700",

    bg:
      "bg-amber-50 border-amber-200",

    text:
      "Görüşmede öğrencinin akademik yük algısı, zaman yönetimi, dinlenme düzeni, görevleri yetiştirme baskısı ve günlük sorumluluklar karşısındaki zorlanma düzeyi araştırılabilir."
  };
}

 // 5. İzlem ve İşbirliği Kararı
//
// DASS-21 skoru tek başına:
// - veliye otomatik bildirim,
// - öğretmene otomatik bildirim,
// - uzman sevki
// kararı oluşturmaz.
//
// Önce psikolojik danışman tarafından bireysel görüşme,
// işlevsellik ve bağlam değerlendirilir.

let familyCollab = {

  l:
    "RUTİN İZLEME",

  c:
    "text-blue-700",

  bg:
    "bg-blue-50 border-blue-200",

  text:
    "Sonuçlar rutin PDR izlemi içinde değerlendirilebilir. Aile veya öğretmen işbirliği gereksinimi, öğrencinin bireysel görüşmedeki durumu ve okul yaşantısı dikkate alınarak belirlenmelidir."
};


if (
  maxSeverity === 2
) {

  familyCollab = {

    l:
      "BİREYSEL GÖRÜŞME ÖNERİLİR",

    c:
      "text-orange-700",

    bg:
      "bg-orange-50 border-orange-200",

    text:
      "En az bir alt boyutta orta düzeyde yükselme bulunmaktadır. Öğrenciyle bireysel görüşme yapılarak belirtilerin günlük işlevselliğe etkisi ve destek ihtiyacı değerlendirilmelidir."
  };

}

else if (
  maxSeverity === 3
) {

  familyCollab = {

    l:
      "ÖNCELİKLİ BİREYSEL DEĞERLENDİRME",

    c:
      "text-red-700",

    bg:
      "bg-red-50 border-red-200",

    text:
      "En az bir alt boyutta ileri düzeyde yükselme bulunmaktadır. Psikolojik danışman tarafından öncelikli bireysel değerlendirme yapılması; aile, öğretmen veya başka bir destek kaynağıyla işbirliği gerekip gerekmediğinin bu değerlendirme sonrasında belirlenmesi uygundur."
  };

}

else if (
  maxSeverity >= 4
) {

  familyCollab = {

    l:
      "AYRINTILI DEĞERLENDİRME ÖNCELİĞİ",

    c:
      "text-rose-700",

    bg:
      "bg-rose-50 border-rose-200",

    text:
      "En az bir alt boyutta çok ileri düzeyde yükselme bulunmaktadır. Öğrencinin bireysel görüşmede ayrıntılı olarak değerlendirilmesi; işlevsellik, mevcut destekler ve ek değerlendirme gereksinimi dikkate alınarak uygun destek veya uzman yönlendirmesinin psikolojik danışman tarafından planlanması önerilir."
  };
}

// 6. Görüşme ve Destek Odağı
//
// Bu bölüm doğrudan bir teknik veya terapi yaklaşımı
// reçete etmez.
//
// Önce öğrencinin yaşantısı, günlük işlevselliği ve
// zorlanmanın bağlamı görüşmede değerlendirilir.
// Destek adımları bu değerlendirmeye göre seçilir.

const focusAreas = {

  "Depresyon":
    "Enerji, Motivasyon ve Günlük İşlevsellik",

  "Anksiyete":
    "Kaygı Bağlamı ve Bedensel Uyarılma",

  "Stres":
    "Yük Algısı, Gerginlik ve Günlük Rutinler",

  "Birleşik":
    "Birden Fazla Zorlanma Alanının Birlikte Değerlendirilmesi",

  "Dengeli":
    "Koruyucu Faktörler ve Mevcut Güçlü Yönler"
};


const therapeuticSteps = {

  "Depresyon":
    "Görüşmede öğrencinin enerji ve motivasyonundaki değişimleri, günlük rutinlerini, görevlere başlama güçlüğünü ve olumlu etkinliklere katılımını araştırın. Zorlanma doğrulanırsa öğrenciyle birlikte küçük, ulaşılabilir ve okul yaşamına uygun hedefler belirleyin.",

  "Anksiyete":
    "Kaygının hangi durumlarda yükseldiğini, öğrencinin bedensel belirtileri nasıl yaşadığını ve kaçınma davranışı olup olmadığını görüşmede değerlendirin. Gerekiyorsa öğrenciye uygun kısa öz-düzenleme, gevşeme veya dikkatini yeniden toplama becerilerinden biri birlikte seçilip denenebilir.",

  "Stres":
    "Öğrencinin kendisini en fazla zorlayan akademik ve sosyal yükleri, zaman baskısını, dinlenme olanaklarını ve günlük rutinlerini birlikte inceleyin. Gerekiyorsa önceliklendirme, görevleri küçük parçalara ayırma ve gerçekçi planlama üzerinde çalışın.",

  "Birleşik":
    "Tek bir alt boyutu merkeze almak yerine öğrencinin enerji, kaygı, gerginlik ve günlük işlevselliğini birlikte değerlendirin. İlk destek adımını puanların büyüklüğüne göre değil, öğrencinin görüşmede en fazla zorlandığını belirttiği ve işlevselliğini en çok etkileyen alana göre seçin.",

  "Dengeli":
    "Öğrencinin mevcut başa çıkma kaynaklarını, destek aldığı kişileri ve okul yaşamında iyi giden alanları görünür hale getirin. Yeni bir müdahale oluşturmak yerine mevcut koruyucu faktörlerin sürdürülmesini ve gerektiğinde rutin izlemi destekleyin."
};

  return (
    <div className="space-y-6 print:space-y-5 font-sans">
      
      {/* 1. SATIR: HEADER */}
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div><h2 className="text-xl print:text-lg font-bold leading-none mb-1">DASS-21 Duygusal Zorlanma ve Destek İhtiyacı Raporu</h2><span className="text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">{meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}</span></div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300"><span className="text-2xl print:text-xl font-black block leading-none">{maxScoreVal}</span><span className="text-[9px] block opacity-70 uppercase font-bold">Tepe Skor</span></div>
      </div>

      {/* 2. SATIR: 3'LÜ ANA BAROMETRELER */}
      <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-6 print:gap-4">
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
             <div className="flex items-center mb-3 print:mb-2 border-b border-slate-100 pb-2"><Activity className="h-5 w-5 print:h-5 print:w-5 text-indigo-500 mr-2"/><div><span className="text-sm print:text-[13px] font-black text-slate-800 uppercase tracking-widest block leading-none">DEPRESYON</span><span className="text-[10px] print:text-[9px] font-medium text-slate-400 uppercase tracking-wide">Çökkünlük Belirtileri</span></div></div>
             <div className="flex items-center justify-between mb-2"><span className={`text-base print:text-sm font-black ${dep.c}`}>{dep.l}</span><span className="text-xs print:text-[11px] font-bold text-slate-400">{scores.D} Puan</span></div>
             <div className="h-2.5 print:h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-1.5"><div className={`h-full ${dep.bg}`} style={{ width: `${dep.p}%` }}></div></div>
             <p className="text-[9px] print:text-[8px] text-slate-400 font-medium text-right">(Eşik: 10)</p>
         </div>
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
             <div className="flex items-center mb-3 print:mb-2 border-b border-slate-100 pb-2"><HeartPulse className="h-5 w-5 print:h-5 print:w-5 text-rose-500 mr-2"/><div><span className="text-sm print:text-[13px] font-black text-slate-800 uppercase tracking-widest block leading-none">ANKSİYETE</span><span className="text-[10px] print:text-[9px] font-medium text-slate-400 uppercase tracking-wide">Kaygı ve Bedensel Uyarılma</span></div></div>
             <div className="flex items-center justify-between mb-2"><span className={`text-base print:text-sm font-black ${anx.c}`}>{anx.l}</span><span className="text-xs print:text-[11px] font-bold text-slate-400">{scores.A} Puan</span></div>
             <div className="h-2.5 print:h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-1.5"><div className={`h-full ${anx.bg}`} style={{ width: `${anx.p}%` }}></div></div>
             <p className="text-[9px] print:text-[8px] text-slate-400 font-medium text-right">(Eşik: 8)</p>
         </div>
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
             <div className="flex items-center mb-3 print:mb-2 border-b border-slate-100 pb-2"><Zap className="h-5 w-5 print:h-5 print:w-5 text-amber-500 mr-2"/><div><span className="text-sm print:text-[13px] font-black text-slate-800 uppercase tracking-widest block leading-none">STRES</span><span className="text-[10px] print:text-[9px] font-medium text-slate-400 uppercase tracking-wide">Gerginlik & Tahammülsüzlük</span></div></div>
             <div className="flex items-center justify-between mb-2"><span className={`text-base print:text-sm font-black ${str.c}`}>{str.l}</span><span className="text-xs print:text-[11px] font-bold text-slate-400">{scores.S} Puan</span></div>
             <div className="h-2.5 print:h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-1.5"><div className={`h-full ${str.bg}`} style={{ width: `${str.p}%` }}></div></div>
             <p className="text-[9px] print:text-[8px] text-slate-400 font-medium text-right">(Eşik: 15)</p>
         </div>
      </div>

    {/* 3. SATIR: DASS-21 PROFİL ÖZETİ VE SOMATİK REAKTİVİTE */}
<div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-6 print:gap-4">
    <div className={`p-5 print:p-4 rounded-2xl border shadow-sm flex flex-col justify-center ${profileSummary.bg}`}>
        <div className="flex items-center mb-1.5">
            <Brain className={`h-5 w-5 print:h-5 print:w-5 mr-2 ${profileSummary.c}`} />

            <span className="text-xs print:text-[11px] font-black uppercase tracking-widest text-slate-800">
                DASS-21 Profil Özeti
            </span>
        </div>

        <div className={`text-sm print:text-[13px] font-black mb-1.5 mt-1 ${profileSummary.c}`}>
            {profileSummary.l}
        </div>

        <p className="text-[13px] print:text-[11px] font-medium text-slate-700 leading-snug">
            {profileSummary.text}
        </p>
    </div>
          <div className={`p-5 print:p-4 rounded-2xl border shadow-sm flex flex-col justify-center ${somaticState.bg}`}>
              <div className="flex items-center mb-1.5">
                  <Activity className={`h-5 w-5 print:h-5 print:w-5 mr-2 ${somaticState.c}`} />
                  <span className="text-xs print:text-[11px] font-black uppercase tracking-widest text-slate-800">
  Bedensel Belirti Göstergeleri
</span>
              </div>
              <div className={`text-sm print:text-[13px] font-black mb-1.5 mt-1 ${somaticState.c}`}>{somaticState.l}</div>
              <p className="text-[13px] print:text-[11px] font-medium text-slate-700 leading-snug">{somaticState.text}</p>
          </div>
      </div>

      {/* 4. SATIR: AKADEMİK ETKİ VE AİLE İŞBİRLİĞİ */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-6 print:gap-4">
          <div className={`p-5 print:p-4 rounded-2xl border shadow-sm flex flex-col justify-center ${academicImpact.bg}`}>
              <div className="flex items-center mb-1.5">
                  <GraduationCap className={`h-5 w-5 print:h-5 print:w-5 mr-2 ${academicImpact.c}`} />
                  <span className="text-xs print:text-[11px] font-black uppercase tracking-widest text-slate-800">Okul Yaşantısında Değerlendirilecek Alanlar</span>
              </div>
              <div className={`text-sm print:text-[13px] font-black mb-1.5 mt-1 ${academicImpact.c}`}>{academicImpact.l}</div>
              <p className="text-[13px] print:text-[11px] font-medium text-slate-700 leading-snug">{academicImpact.text}</p>
          </div>
          <div className={`p-5 print:p-4 rounded-2xl border shadow-sm flex flex-col justify-center ${familyCollab.bg}`}>
              <div className="flex items-center mb-1.5">
                  <Users className={`h-5 w-5 print:h-5 print:w-5 mr-2 ${familyCollab.c}`} />
                  <span className="text-xs print:text-[11px] font-black uppercase tracking-widest text-slate-800">İzlem ve İşbirliği Kararı</span>
              </div>
              <div className={`text-sm print:text-[13px] font-black mb-1.5 mt-1 ${familyCollab.c}`}>{familyCollab.l}</div>
              <p className="text-[13px] print:text-[11px] font-medium text-slate-700 leading-snug">{familyCollab.text}</p>
          </div>
      </div>

      {/* 5. SATIR: KLİNİK ODAK VE ACİL MÜDAHALE ADIMI */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-6 print:gap-4">
          <div className="bg-slate-900 p-5 print:p-4 rounded-2xl shadow-sm flex flex-col justify-center print:bg-white print:border print:border-slate-300 print:text-black">
              <div className="flex items-center mb-1.5 opacity-80 print:opacity-100">
                  <AlertCircle className="h-5 w-5 print:h-5 print:w-5 mr-2 text-indigo-400 print:text-indigo-600" />
                  <span className="text-xs print:text-[11px] font-bold uppercase tracking-widest text-slate-300 print:text-slate-500">Öncelikli Değerlendirme Alanı</span>
              </div>
              <div className="text-sm print:text-[13px] font-black text-white print:text-slate-900 mb-1.5 mt-1">Odak: {focusAreas[primaryRisk]}</div>
              <p className="text-[13px] print:text-[11px] font-medium text-slate-400 print:text-slate-600 leading-snug">
                  Bireysel görüşmede öncelikle ele alınabilecek alan <strong>{primaryRisk}</strong> göstergeleridir.
              </p>
          </div>
          <div className="bg-indigo-50 p-5 print:p-4 rounded-2xl border border-indigo-100 shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300">
              <div className="flex items-center mb-1.5">
                  <Shield className="h-5 w-5 print:h-5 print:w-5 mr-2 text-indigo-600" />
                  <span className="text-xs print:text-[11px] font-black uppercase tracking-widest text-indigo-900">İlk PDR Destek Adımı</span>
              </div>
              <div className="text-sm print:text-[13px] font-black text-indigo-800 mb-1.5 mt-1">Görüşme ve Destek Odağı</div>
              <p className="text-[13px] print:text-[11px] font-medium text-indigo-900 leading-snug text-justify">
                  {therapeuticSteps[primaryRisk]}
              </p>
          </div>
      </div>

      {/* FOOTER BİLGİ */}
      <div className="bg-slate-50 p-4 print:p-3 rounded-xl border border-slate-200 text-xs print:text-[10px] text-slate-500 text-center italic mt-4 print:mt-2">
        * Puanlar, uluslararası DASS-42 normatif verileriyle eşleşebilmesi için bilimsel standarda uygun olarak (x2) katsayısı ile standardize edilmiştir.
      </div>
    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateDass21 = (subs) => {

  const total =
    subs.length;


  if (total === 0) {
    return null;
  }


  // İleri / Çok İleri düzeyde en az bir alt boyutu
  // bulunan öğrenciler.
  let priorityStudents = 0;


  // Orta düzeyde en az bir alt boyutu bulunan,
  // ancak "öncelikli" gruba girmeyen öğrenciler.
  let followUpStudents = 0;


  let totalD = 0;
  let totalA = 0;
  let totalS = 0;


  // Her alt boyutta normal aralığın üzerinde
  // kaç öğrenci bulunduğunu tutuyoruz.
  let countRiskD = 0;
  let countRiskA = 0;
  let countRiskS = 0;


  const classMap = {};


  subs.forEach(
    s => {

      const className =
        s.studentClass ||
        s.sinif ||
        s.sınıf ||
        s.class ||
        s.grade ||
        s.studentInfo?.sinif ||
        "Tüm Sınıflar";


      if (!classMap[className]) {

        classMap[className] = {
          name:
            className,

          studentCount:
            0,

          priorityWeight:
            0
        };
      }


      classMap[className]
        .studentCount++;


      const rawScores =
        s.reportData?.scores || {};


      const scores = {
        D:
          Number(rawScores.D) || 0,

        A:
          Number(rawScores.A) || 0,

        S:
          Number(rawScores.S) || 0
      };


      totalD +=
        scores.D;

      totalA +=
        scores.A;

      totalS +=
        scores.S;


      // Normal aralığın üzerindeki öğrenci sayıları.
      // Burada D/A/S ham puanlarını birbirleriyle
      // karşılaştırmıyoruz.
      if (
        scores.D >= 10
      ) {
        countRiskD++;
      }


      if (
        scores.A >= 8
      ) {
        countRiskA++;
      }


      if (
        scores.S >= 15
      ) {
        countRiskS++;
      }


      // İleri veya Çok İleri düzey:
      // Öncelikli bireysel değerlendirme grubu.
      const isPriority =
        scores.D >= 21 ||
        scores.A >= 15 ||
        scores.S >= 26;


      // Orta düzey:
      // İzlem / bireysel görüşme grubu.
      const isFollowUp =
        !isPriority &&
        (
          scores.D >= 14 ||
          scores.A >= 10 ||
          scores.S >= 19
        );


      if (
        isPriority
      ) {

        priorityStudents++;

        classMap[className]
          .priorityWeight += 1;

      }

      else if (
        isFollowUp
      ) {

        followUpStudents++;

        classMap[className]
          .priorityWeight += 0.5;
      }
    }
  );


  const avgD =
    Math.round(
      totalD / total
    );


  const avgA =
    Math.round(
      totalA / total
    );


  const avgS =
    Math.round(
      totalS / total
    );


  // ------------------------------------------------------------
  // KURUMSAL BASKIN ALAN
  //
  // Eski sistem:
  // Her öğrencinin D/A/S ham puanlarından en büyüğünü seçiyordu.
  //
  // Yeni sistem:
  // Kurumda hangi alt boyutta normal aralığın üzerinde
  // daha fazla öğrenci bulunduğuna bakıyoruz.
  // ------------------------------------------------------------

  const elevatedCounts = {
    D:
      countRiskD,

    A:
      countRiskA,

    S:
      countRiskS
  };


  const maxElevated =
    Math.max(
      elevatedCounts.D,
      elevatedCounts.A,
      elevatedCounts.S
    );


  const dominantAreas =
    maxElevated > 0

      ? Object.entries(
          elevatedCounts
        )
          .filter(
            ([, count]) =>
              count ===
              maxElevated
          )
          .map(
            ([area]) =>
              area
          )

      : [];


  let dominantSymptom = {

    name:
      "Eşik Altı Genel Profil",

    code:
      "N",

    desc:
      "Depresyon, anksiyete ve stres alt boyutlarında normal aralığın üzerinde öğrenci oranı belirgin biçimde öne çıkmamaktadır."
  };


  if (
    dominantAreas.length > 1
  ) {

    dominantSymptom = {

      name:
        "Birleşik Zorlanma Profili",

      code:
        "M",

      desc:
        "Birden fazla DASS-21 alt boyutunda benzer oranda yükselme görülmektedir. Kurumsal tablo tek bir zorlanma alanına indirgenmeden değerlendirilmelidir."
    };

  }

  else if (
    dominantAreas[0] === "D"
  ) {

    dominantSymptom = {

      name:
        "Çökkünlük Belirtileri",

      code:
        "D",

      desc:
        "Normal aralığın üzerinde sonuç veren öğrencilerin en fazla yoğunlaştığı alt boyut depresyondur. Bunun öğrencilerin okul yaşantısındaki karşılığı ek değerlendirmelerle ele alınmalıdır."
    };

  }

  else if (
    dominantAreas[0] === "A"
  ) {

    dominantSymptom = {

      name:
        "Kaygı Belirtileri",

      code:
        "A",

      desc:
        "Normal aralığın üzerinde sonuç veren öğrencilerin en fazla yoğunlaştığı alt boyut anksiyetedir. Kaygının hangi okul ve yaşam bağlamlarında yoğunlaştığı ayrıca değerlendirilmelidir."
    };

  }

  else if (
    dominantAreas[0] === "S"
  ) {

    dominantSymptom = {

      name:
        "Stres Belirtileri",

      code:
        "S",

      desc:
        "Normal aralığın üzerinde sonuç veren öğrencilerin en fazla yoğunlaştığı alt boyut strestir. Bu sonuç, grubun yük ve gerginlik deneyiminin bağlamıyla birlikte değerlendirilmelidir."
    };
  }


  const riskDistribution = [

    {
      name: "Depresyon - Normal Üzeri",

      percent:
        Math.round(
          (
            countRiskD /
            total
          ) * 100
        ),

      color:
        "bg-indigo-500"
    },

    {
      name: "Anksiyete - Normal Üzeri",

      percent:
        Math.round(
          (
            countRiskA /
            total
          ) * 100
        ),

      color:
        "bg-rose-500"
    },

    {
      name: "Stres - Normal Üzeri",

      percent:
        Math.round(
          (
            countRiskS /
            total
          ) * 100
        ),

      color:
        "bg-amber-500"
    }

  ].sort(
    (a, b) =>
      b.percent -
      a.percent
  );


  const classStats =
    Object.values(
      classMap
    )
      .map(
        c => {

          const priorityIntensity =
            c.studentCount > 0

              ? Math.round(
                  (
                    c.priorityWeight /
                    c.studentCount
                  ) * 100
                )

              : 0;


          return {
            ...c,

            priorityIntensity,

            // Geçici geriye dönük uyumluluk:
            // mevcut arayüz henüz riskIntensity okuyor.
            riskIntensity:
              priorityIntensity
          };
        }
      )
      .sort(
        (a, b) =>
          b.priorityIntensity -
          a.priorityIntensity
      );


  return {

    total,

    priorityStudents,
    followUpStudents,

    // Geçici geriye dönük uyumluluk.
    // Sonraki patch'te arayüzü bu eski adlardan kurtaracağız.
    redAlarmStudents:
      priorityStudents,

    yellowAlarmStudents:
      followUpStudents,

    avgD,
    avgA,
    avgS,

    dominantSymptom,

    riskDistribution,

    classStats
  };
};

// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const Dass21KurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateDass21(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const isRedAlarm =
  data.priorityStudents > 0;


const priorityPercent =
  data.total > 0
    ? Math.round(
        (
          data.priorityStudents /
          data.total
        ) * 100
      )
    : 0;


const followUpPercent =
  data.total > 0
    ? Math.round(
        (
          data.followUpStudents /
          data.total
        ) * 100
      )
    : 0;

  let interventionObj = {};
  let stakeholderObj = {};

  if (data.dominantSymptom.code === "D") {

    interventionObj = {
        title: "Çökkünlük Belirtilerinde Değerlendirme Odağı",

        icon: Activity,

        color: "text-indigo-700",

        bg: "bg-indigo-50 print:bg-white border-indigo-200 print:border-slate-300",

        desc:
            "Normal aralığın üzerindeki sonuçların en fazla yoğunlaştığı alt boyut depresyondur. Bu toplu bulgu tek başına tükenmişlik, akademik kopuş veya belirli bir işlev kaybının varlığını göstermez.",

        bullets: [
            "PDR servisi, yükselmenin hangi sınıf ve öğrenci gruplarında yoğunlaştığını ayrıca incelemelidir.",
            "Bireysel görüşmelerde enerji, motivasyon, günlük rutinler ve okul işlevselliğindeki olası değişimler doğrulanmalıdır.",
            "İleri veya çok ileri düzey sonuç veren öğrenciler bireysel olarak değerlendirilmeli; ek uzman değerlendirmesi gereksinimi görüşme ve işlevsellik bulgularına göre belirlenmelidir."
        ]
    };


    stakeholderObj = {
        title: "Destekleyici Katılım ve Gözlem",

        icon: Users,

        color: "text-blue-700",

        bg: "bg-blue-50 print:bg-white border-blue-200 print:border-slate-300",

        desc:
            "Toplu DASS-21 sonucu tek başına içe kapanma, uyku-iştah değişikliği veya akademik performans kaybı olduğunu göstermez. Bu alanlar yalnızca gerektiğinde diğer okul verileri ve bireysel görüşmeyle araştırılmalıdır.",

        bullets: [
            "Öğretmenler: Öğrencilerin derse katılımı, enerji düzeyi ve günlük işlevselliğinde belirgin değişimler gözleniyorsa PDR servisiyle paylaşabilir.",
            "Veli iletişimi: Toplu puana dayanarak otomatik bilgilendirme yapılmamalı; iletişim gereksinimi öğrencinin bireysel değerlendirmesine göre belirlenmelidir.",
            "İdare: Öğrencilerin okula katılımını ve destek kaynaklarına erişimini güçlendiren kapsayıcı çalışmalar desteklenebilir."
        ]
    };

}

else if (data.dominantSymptom.code === "A") {

    interventionObj = {
        title: "Kaygı Belirtilerinde Değerlendirme Odağı",

        icon: HeartPulse,

        color: "text-rose-700",

        bg: "bg-rose-50 print:bg-white border-rose-200 print:border-slate-300",

        desc:
            "Normal aralığın üzerindeki sonuçların en fazla yoğunlaştığı alt boyut anksiyetedir. Bu bulgu tek başına panik, sınav kaygısı veya belirli bedensel belirtilerin varlığını kanıtlamaz.",

        bullets: [
            "Kaygının hangi sınıf, dönem veya öğrenci gruplarında daha belirgin olduğu ayrıca incelenmelidir.",
            "Bireysel görüşmelerde kaygının ortaya çıktığı durumlar, kaçınma örüntüleri ve öğrencinin günlük işlevselliğine etkisi değerlendirilmelidir.",
            "Grup düzeyinde destek gereksinimi doğrulanırsa kaygıyı tanıma, yardım arama ve öz-düzenleme becerilerine yönelik gelişimsel çalışmalar planlanabilir."
        ]
    };


    stakeholderObj = {
        title: "Güvenli ve Öngörülebilir Okul Ortamı",

        icon: ShieldCheck,

        color: "text-pink-700",

        bg: "bg-pink-50 print:bg-white border-pink-200 print:border-slate-300",

        desc:
            "DASS-21 sonucu, kaygının nedeninin öğretmen, veli, sınav sistemi veya performans baskısı olduğunu tek başına göstermez. Olası okul bağlamları ek verilerle değerlendirilmelidir.",

        bullets: [
            "Öğretmenler: Gereksiz performans baskısını azaltan, beklentileri açık ve öngörülebilir değerlendirme süreçleri desteklenebilir.",
            "Veli iletişimi: Kaygının aile tutumlarından kaynaklandığı varsayılmamalı; aile işbirliği bireysel değerlendirme sonucunda planlanmalıdır.",
            "İdare: Kaygı yükselmelerinin belirli sınav veya değerlendirme dönemlerinde yoğunlaşıp yoğunlaşmadığı diğer okul verileriyle birlikte incelenebilir."
        ]
    };

}

else if (data.dominantSymptom.code === "S") {

    interventionObj = {
        title: "Stres Belirtilerinde Değerlendirme Odağı",

        icon: Zap,

        color: "text-amber-700",

        bg: "bg-amber-50 print:bg-white border-amber-200 print:border-slate-300",

        desc:
            "Normal aralığın üzerindeki sonuçların en fazla yoğunlaştığı alt boyut strestir. Bu bulgu tek başına aşırı akademik yük, çatışma, öfke davranışı veya tükenmişlik bulunduğunu göstermez.",

        bullets: [
            "Stres yükselmesinin hangi sınıf, dönem ve öğrenci gruplarında yoğunlaştığı ayrıca değerlendirilmelidir.",
            "Bireysel görüşmelerde öğrencinin algıladığı yük, gerginlik, zaman baskısı, dinlenme olanakları ve günlük rutinleri araştırılabilir.",
            "İhtiyaç doğrulanırsa planlama, önceliklendirme, görevleri küçük parçalara ayırma ve uygun başa çıkma becerilerine yönelik grup çalışmaları planlanabilir."
        ]
    };


    stakeholderObj = {
        title: "Yük ve Okul Koşullarının Gözden Geçirilmesi",

        icon: Target,

        color: "text-orange-700",

        bg: "bg-orange-50 print:bg-white border-orange-200 print:border-slate-300",

        desc:
            "Yüksek stres sonuçlarının doğrudan okulun akademik taleplerinden kaynaklandığı varsayılmamalıdır. Akademik yük, zaman baskısı ve dinlenme olanakları diğer okul verileriyle birlikte değerlendirilmelidir.",

        bullets: [
            "Öğretmenler: Ödev ve değerlendirme yoğunluğu ancak diğer veriler de yüklenmeye işaret ediyorsa koordineli biçimde gözden geçirilebilir.",
            "Veli iletişimi: Öğrencinin okul dışı sorumlulukları ve dinlenme düzeni gerekiyorsa bireysel görüşme çerçevesinde ele alınabilir.",
            "İdare: Ders, sınav ve dinlenme düzeninde belirgin yoğunlaşmalar olup olmadığı kurumsal verilerle birlikte incelenebilir."
        ]
    };

}

else if (data.dominantSymptom.code === "M") {

    interventionObj = {
        title: "Birleşik Duygusal Zorlanma Profili",

        icon: Brain,

        color: "text-violet-700",

        bg: "bg-violet-50 print:bg-white border-violet-200 print:border-slate-300",

        desc:
            "Birden fazla DASS-21 alt boyutunda benzer oranda yükselme görülmektedir. Kurumsal tablo tek bir zorlanma alanına indirgenmeden değerlendirilmelidir.",

        bullets: [
            "PDR servisi, yükselen alt boyutların hangi sınıf ve öğrenci gruplarında yoğunlaştığını ayrıca incelemelidir.",
            "Grup çalışmaları tek bir belirti alanına göre değil; duygu düzenleme, yardım arama ve başa çıkma becerileri gibi ortak koruyucu alanlar üzerinden planlanabilir.",
            "İleri veya çok ileri düzey sonuç veren öğrenciler toplu sonuçtan bağımsız olarak bireysel değerlendirmede ele alınmalıdır."
        ]
    };


    stakeholderObj = {
        title: "Çok Boyutlu Destek Yaklaşımı",

        icon: Users,

        color: "text-violet-700",

        bg: "bg-violet-50 print:bg-white border-violet-200 print:border-slate-300",

        desc:
            "Toplu sonuçlar, birden fazla zorlanma alanının birlikte değerlendirilmesinin daha uygun olabileceğine işaret etmektedir.",

        bullets: [
            "Öğretmenler: Öğrencilerin zorlanmasını tek bir davranış veya akademik gösterge üzerinden açıklamaktan kaçınmalıdır.",
            "Veli iletişimi: Genel alarm dili yerine öğrencinin gözlenen işlevselliği ve bireysel ihtiyacı üzerinden yürütülmelidir.",
            "İdare: PDR servisinin sınıf ve birey düzeyindeki değerlendirmelerini destekleyecek önleyici ve gelişimsel çalışmalar desteklenebilir."
        ]
    };

}

else {

    interventionObj = {
        title: "Önleyici ve Gelişimsel Rehberlik",

        icon: Brain,

        color: "text-emerald-700",

        bg: "bg-emerald-50 print:bg-white border-emerald-200 print:border-slate-300",

        desc:
            "DASS-21 alt boyutlarında normal aralığın üzerinde sonuç veren öğrenci oranları arasında belirgin biçimde öne çıkan bir alan bulunmamaktadır. Bu durum tüm öğrencilerin iyi oluşunun yüksek olduğu veya destek ihtiyacı bulunmadığı anlamına gelmez.",

        bullets: [
            "Evrensel önleyici ve gelişimsel rehberlik çalışmalarına rutin biçimde devam edilebilir.",
            "DASS-21 sonuçları devamsızlık, okul uyumu, öğretmen gözlemleri ve diğer PDR verileriyle birlikte değerlendirilmelidir.",
            "Toplu görünüm düşük olsa bile diğer değerlendirme kaynaklarında destek ihtiyacı görülen öğrenciler bireysel olarak ele alınmalıdır."
        ]
    };


    stakeholderObj = {
        title: "Sürdürülebilir Destekleyici Okul İklimi",

        icon: Compass,

        color: "text-teal-700",

        bg: "bg-teal-50 print:bg-white border-teal-200 print:border-slate-300",

        desc:
            "Toplu sonuçlarda tek bir alt boyutun belirgin biçimde öne çıkmaması, koruyucu ve gelişimsel okul çalışmalarının sürdürülmesi için bir izlem noktası olarak kullanılabilir.",

        bullets: [
            "Öğretmenler: Akademik gelişimin yanında öğrencilerin okul aidiyeti ve yardım arama davranışlarını desteklemeye devam edebilir.",
            "Veli iletişimi: Genel bilgilendirme ve koruyucu rehberlik içerikleri sürdürülebilir.",
            "PDR servisi: Kurumsal eğilimleri dönemsel olarak izleyip anlamlı değişimleri diğer okul verileriyle birlikte değerlendirebilir."
        ]
    };
}



// ------------------------------------------------------------
// DASS-21 KURUMSAL AI VERİ PAKETİ
//
// AI'ya öğrenci adı / numarası gibi kişisel veri göndermiyoruz.
// Yalnızca anonim ve toplulaştırılmış kurumsal göstergeleri
// gönderiyoruz.
// ------------------------------------------------------------

const aiSummaryItems = [

  `Katılımcı sayısı: ${data.total}`,

  `Depresyon ortalama puanı: ${data.avgD}`,

  `Anksiyete ortalama puanı: ${data.avgA}`,

  `Stres ortalama puanı: ${data.avgS}`,

  `Öncelikli bireysel değerlendirme grubu: ${data.priorityStudents} öğrenci (%${priorityPercent})`,

  `İzlem / görüşme grubu: ${data.followUpStudents} öğrenci (%${followUpPercent})`,

  `En yaygın yükselme alanı: ${data.dominantSymptom.name}`,

  `Kurumsal profil açıklaması: ${data.dominantSymptom.desc}`,

  ...data.riskDistribution.map(
    item =>
      `${item.name}: %${item.percent}`
  ),

  ...(data.classStats?.length
    ? [
        `Sınıf öncelik görünümü: ${data.classStats
          .slice(0, 5)
          .map(
            item =>
              `${item.name} (%${item.priorityIntensity})`
          )
          .join(", ")}`
      ]
    : [])
];

 

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('dass21-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="dass21-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        
        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - KLİNİK ÖZET VİTRİNİ                 */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className={`p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'} shrink-0 avoid-break`}>
            <div className="flex items-center gap-5 print:gap-3">
              <div className={`h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
                <Activity className="h-7 w-7 print:h-5 print:w-5"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   DASS-21 • KURUMSAL DUYGUSAL ZORLANMA VE DESTEK HARİTASI
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className={`text-3xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-800'}`}>{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

                     <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">

  {/* 1. ÖNCELİKLİ BİREYSEL DEĞERLENDİRME */}
  <div
    className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300 ${
      isRedAlarm
        ? 'border-red-200'
        : 'border-slate-200'
    }`}
  >
    <div className="flex items-center mb-1.5">

      <AlertTriangle
        className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${
          isRedAlarm
            ? 'text-red-500'
            : 'text-emerald-500'
        }`}
      />

      <span
        className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${
          isRedAlarm
            ? 'text-red-600'
            : 'text-emerald-600'
        }`}
      >
        Öncelikli Bireysel Değerlendirme
      </span>

    </div>

    <p
      className={`text-2xl print:text-lg font-black mt-1 ${
        isRedAlarm
          ? 'text-red-700'
          : 'text-emerald-700'
      }`}
    >
      {data.priorityStudents}

      <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">
        {' '}Öğrenci (%{priorityPercent})
      </span>
    </p>
  </div>


  {/* 2. EN YAYGIN YÜKSELME ALANI */}
  <div className="bg-indigo-50 p-5 print:p-3 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">

    <div className="flex items-center mb-1.5">

      <Brain className="h-6 w-6 print:h-4 print:w-4 mr-2 text-indigo-600"/>

      <span className="text-sm print:text-[10px] font-black text-indigo-600 uppercase tracking-widest">
        En Yaygın Yükselme Alanı
      </span>

    </div>

    <p className="text-base print:text-[12px] font-black text-indigo-900 mt-1 leading-tight">
      {data.dominantSymptom.name}
    </p>

  </div>


  {/* 3. İZLEM / GÖRÜŞME GRUBU */}
  <div className="bg-amber-50 p-5 print:p-3 rounded-2xl border border-amber-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">

    <div className="flex items-center mb-1.5">

      <Users className="h-6 w-6 print:h-4 print:w-4 mr-2 text-amber-600"/>

      <span className="text-sm print:text-[10px] font-black text-amber-600 uppercase tracking-widest">
        İzlem / Görüşme Grubu
      </span>

    </div>

    <p className="text-2xl print:text-lg font-black text-amber-900 mt-1">

      {data.followUpStudents}

      <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">
        {' '}Öğrenci (%{followUpPercent})
      </span>

    </p>

  </div>

</div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
            
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-blue-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-blue-200 print:border-slate-200 pb-1.5">
                 <Users className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> Sınıf Öncelik Haritası
               </h3>
               <div className="space-y-2 print:space-y-1 mt-1">
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">1. Öncelikli Grup</span>
                    <p className="text-sm print:text-[10px] font-black text-slate-800 leading-tight truncate">
                      {data.classStats[0] ? data.classStats[0].name : 'Belirsiz'}
                      {data.classStats[0] && <span className="text-[10px] print:text-[8px] font-bold text-red-600 ml-1">(Öncelik İndeksi: %{data.classStats[0].riskIntensity})</span>}
                    </p>
                  </div>
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">2. Öncelikli Grup</span>
                    <p className="text-xs print:text-[9px] font-black text-slate-700 leading-tight truncate">
                      {data.classStats[1] ? data.classStats[1].name : 'İkinci Grup Bulunmuyor'}
                      {data.classStats[1] && <span className="text-[10px] print:text-[8px] font-bold text-red-500 ml-1">(Öncelik İndeksi: %{data.classStats[1].riskIntensity})</span>}
                    </p>
                  </div>
               </div>
            </div>

            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-purple-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-purple-200 print:border-slate-200 pb-1.5">
                 <Scale className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-purple-600"/> Ortalama Alt Ölçek Puanları
               </h3>
               
               <div className="space-y-1.5 print:space-y-1.5 mt-1">
                  <div className="flex justify-between items-center text-[10px] print:text-[8.5px] font-bold">
                      <span className="text-indigo-700">DEPRESYON</span>
                      <span>{data.avgD} Puan</span>
                  </div>
                  <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden print:border print:border-slate-300"><div className="h-full bg-indigo-500 print:bg-slate-700" style={{width: `${(data.avgD/42)*100}%`}}></div></div>
                  
                  <div className="flex justify-between items-center text-[10px] print:text-[8.5px] font-bold">
                      <span className="text-rose-700">ANKSİYETE</span>
                      <span>{data.avgA} Puan</span>
                  </div>
                  <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden print:border print:border-slate-300"><div className="h-full bg-rose-500 print:bg-slate-700" style={{width: `${(data.avgA/42)*100}%`}}></div></div>

                  <div className="flex justify-between items-center text-[10px] print:text-[8.5px] font-bold">
                      <span className="text-amber-700">STRES</span>
                      <span>{data.avgS} Puan</span>
                  </div>
                  <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden print:border print:border-slate-300"><div className="h-full bg-amber-500 print:bg-slate-700" style={{width: `${(data.avgS/42)*100}%`}}></div></div>
               </div>
            </div>

            <div className="col-span-2 bg-slate-50 p-4 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none flex items-center gap-3">
               <div className="shrink-0 bg-slate-200 print:bg-slate-100 p-2.5 print:p-2 rounded-xl">
                 <BrainCircuit className="h-6 w-6 print:h-4 print:w-4 text-slate-700"/>
               </div>
               <div>
                 <h3 className="font-bold text-slate-800 text-xs print:text-[10px] uppercase tracking-widest mb-1">Kurumsal Psikososyal Durum</h3>
                 <p className="text-sm print:text-[10.5px] font-medium text-slate-700 print:text-slate-800 leading-tight">
                   {data.dominantSymptom.desc}
                 </p>
               </div>
            </div>

            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <BarChart3 className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Normal Aralığın Üzerindeki Öğrenci Oranı
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-slate-500 italic">Alt Ölçek Bazında Yüzde</span>
               </div>
               
               <div className="space-y-3 print:space-y-2">
                  {data.riskDistribution.map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.name}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">%{dim.percent}</span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className={`h-full rounded-full print:bg-slate-600 ${dim.color}`} style={{ width: `${dim.percent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>

          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
             
             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${interventionObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <interventionObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${interventionObj.color}`}/>
                  Öncelikli Değerlendirme Alanı
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${interventionObj.color}`}>
                      {interventionObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {interventionObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {interventionObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${interventionObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

             <div className={`col-span-1 p-5 print:p-4 rounded-2xl border flex flex-col shadow-sm print:shadow-none print:min-h-[140px] ${stakeholderObj.bg}`}>
                <h3 className="font-bold text-slate-800 mb-2 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-slate-200 print:border-slate-200 pb-2">
                  <stakeholderObj.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${stakeholderObj.color}`}/>
                  Paydaşlar İçin Destek Çerçevesi
                </h3>
                <div className="flex-1 flex flex-col justify-start mt-1">
                  <p className={`text-sm print:text-[11px] font-black leading-tight mb-1.5 ${stakeholderObj.color}`}>
                      {stakeholderObj.title}
                  </p>
                  <p className="text-[11px] print:text-[9px] text-slate-600 leading-snug mb-2.5">
                      {stakeholderObj.desc}
                  </p>
                  <ul className="space-y-1.5 print:space-y-1.5 mt-auto">
                    {stakeholderObj.bullets.map((b, i) => (
                      <li key={i} className="flex items-start text-[11px] print:text-[8.5px] text-slate-800 font-medium leading-snug">
                        <span className={`mr-1.5 font-black ${stakeholderObj.color}`}>•</span> {b}
                      </li>
                    ))}
                  </ul>
                </div>
             </div>

          </div>
          
          {/* FOOTER BİLGİ */}
          <div className="text-[9px] print:text-[8px] text-slate-400 italic text-center mt-2 print:mt-1">
             * Puanlar, uluslararası DASS-42 normatif verileriyle eşleşebilmesi için bilimsel standarda uygun olarak (x2) katsayısı ile standardize edilmiştir.
          </div>

        </div>
        {/* ==================== 1. SAYFA SONU ==================== */}

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Kurumsal Ruh Sağlığı ve Destek Planı
              </h3>
              <button onClick={() => onGenerateAI(title, aiSummaryItems)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>

          <div className="hidden print:flex justify-between mt-10 pt-4 text-[10px] text-black px-12 shrink-0 border-t border-slate-300">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-16">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-16">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};